import React, { useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { 
  Card, 
  CardContent, 
  Grid, 
  Button ,
  Typography, 
  Dialog ,
  DialogActions ,
  DialogContent ,
  DialogContentText ,
  DialogTitle ,
  TextField    

} from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.error.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}));

const Total = props => {
  const { className, price, name, onSetSpecialPrice, ...rest } = props;

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [specialPrice, setSpecialPrice] = React.useState('');


  useEffect(() => {
    setSpecialPrice(props.specialprice)
  }, [props.specialprice]);


  const handleClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    setSpecialPrice(props.specialprice)
    setOpen(true);
  }
  const handleSetSpecialPrice = () => {
    onSetSpecialPrice(specialPrice);
    setOpen(false);
  }

  const handleDeleteSpecialPrice = () => {
    onSetSpecialPrice('');
    setOpen(false);
  }

  const handleChange = event => {
    setSpecialPrice(event.target.value);
  };

  return (
    <React.Fragment>
      {
        onSetSpecialPrice && 
      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Специальная цена</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Введите специальную цену для билета. Билет будет считаться оплаченым, если будут введены платежи по специальной цене.
          </DialogContentText>
          <TextField
            autoFocus
            autoComplete="off"
            margin="dense"
            id="price"
            label="Специальная цена"
            value={specialPrice}
            onChange={handleChange}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteSpecialPrice} color="primary">
            Сбросить
          </Button>
          <Button onClick={handleSetSpecialPrice} color="primary">
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
      }


    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent onClick={handleClick}>
        <Grid
          container
          justify="space-between"
        >
          <Grid item >
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
              variant="body2"
            >
              {name}:
            </Typography>
            <Typography variant="h3">{price ? price.toLocaleString('ru') : 0}&nbsp;฿
          </Typography>

          </Grid>
        </Grid>
        {/* <div className={classes.difference}>
        <Chip label="Частично оплачен" size="small"/>
        </div> */}
      </CardContent>
    </Card>
    </React.Fragment>

  );
};

Total.propTypes = {
  className: PropTypes.string
};

export default Total;
